import { render, staticRenderFns } from "./AISkillPanel.vue?vue&type=template&id=c5b3525e&scoped=true"
import script from "./AISkillPanel.vue?vue&type=script&lang=js"
export * from "./AISkillPanel.vue?vue&type=script&lang=js"
import style0 from "./AISkillPanel.vue?vue&type=style&index=0&id=c5b3525e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b3525e",
  null
  
)

export default component.exports